module.exports = __webpack_public_path__ + "static/img/index-title-02.764f7663.png";